import { render } from "./LabelView.vue?vue&type=template&id=7e4f2d58"
import script from "./LabelView.vue?vue&type=script&lang=js"
export * from "./LabelView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/DMA-Frontend/DMA-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__